<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="jar包路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'jarPath', validatorRules.jarPath]" placeholder="请输入jar包在服务器中的路径"></a-input>
        </a-form-item>
        <a-form-item label="启动参数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'startParam', validatorRules.startParam]" placeholder="请输入启动参数(e.g. --server.port=8080)"></a-input>
        </a-form-item>
        <a-form-item label="启动步骤" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-editor :key="editorKey" v-decorator="['nodeStartStep',{trigger:'input'}]"/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JEditor from '@/components/jeecg/JEditor'
  import { getAppServerRelation } from '@/api/api.js'
  export default {
    name: "BusServermanageAppModal",
    components: { 
      JEditor,
    },
    data () {
      return {
        appId:'',
        serverId:'',
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          jarPath:{rules:[]},
          startParam:{rules:[]},
          nodeStartStep:{rules:[]},
        },
        url: {
          edit: "/servermanage/busServermanageAppServer/edit",
        },
        editorKey:new Date().valueOf()
      }
    },
    created () {
    },
    methods: {
      open(appId,serverId){
        this.form.resetFields();
        this.appId = appId;
        this.serverId = serverId;
        // this.visible = true;
         console.log("关系表表单提交数据"+this.appId+"=="+this.serverId)
        getAppServerRelation({serverId:this.serverId,appId:this.appId})
          .then((res) => {
            if (res.success) {
              console.log("res=="+res.result.nodeStartStep)
            //  this.model=res.result
             this.edit(res.result)
            } else {
              this.$message.warning(res.message)
            }
          }).catch((err)=>{
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })

      },
      add () {
        this.edit({izActivity:1});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.editorKey=new Date().valueOf()
          this.form.setFieldsValue(pick(this.model,'jarPath','startParam','nodeStartStep'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = this.url.edit;
            let method = 'post';
            let formData = Object.assign(this.model, values);
            formData.appId = this.appId
            formData.serverId=this.serverId
            console.log("关系表表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','manager','codeUrl','deploytoolUrl','sort','remarks','izActivity','delFlag',''))
      },
      selectOK(selectData){
        console.log(selectData)
        this.form.setFieldsValue({
          manager:selectData[0].username,
        })
      },
      getFormFieldValue(field){
        return this.form.getFieldValue(field)
      },
      openSelectUser(record){
        this.$refs.selectUserModal.add();
      },
    }
  }
</script>